import React from 'react';

import PageSkeleton from '../../components/skeleton/PageSkeleton';
import createRouteLoadable from './createRouteLoadable';

export const NOT_FOUND_PAGE_CHUNK_NAME = 'notFoundPage';

export const NotFoundPage = createRouteLoadable(
  () =>
    import(/* webpackChunkName: "notFoundPage" */ '../../pages/NotFoundPage'),
  {
    fallback: <PageSkeleton />,
  }
);
